import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    flexColumn: {
        display: 'flex' as 'flex',
        flexFlow: 'column nowrap' as 'column nowrap',
        flexGrow: 1,
        alignItems: 'center' as 'center',
        marginTop: '2rem'
    },
    fieldContainer: {
        width: '100%',
        alignSelf: 'flex-start',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '2rem'
    },
    legalText: {
        fontSize: '11px',
        marginTop: '10rem',
        color: 'black',
        '& a, a:hover, a:visited': { fontWeight: 'bold' }
    },
    greenButton: {
        width: '150px',
        marginTop: '0px',
        padding: '0.94rem 0.75rem',
        fontSize: '13px',
        height: '25px',
        backgroundColor: '#5AAC01',
        '&:hover': { backgroundColor: '#A5D673' }
    },
    redButton: {
        width: '130px',
        marginTop: '0px',
        padding: '0.94rem 0.75rem',
        fontSize: '13px',
        height: '25px',
        backgroundColor: '#EA3323',
        '&:hover': { backgroundColor: '#E75F59' }
    },
    assetContainer: {
        width: '100%',
        alignSelf: 'flex-start',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '2rem',
        marginTop: '-2rem'
    },
    fieldGroupHeader: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontSize: '1.5rem',
        marginBottom: '.75rem'
    },
    inputLabelLarge: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontSize: '1rem',
        fontWeight: 'bold' as const,
        // marginBottom: '.6rem',
        marginTop: '.9rem',
        fontFamily: 'corporate-s,sans-serif'
    },
    margin: { marginTop: '-1.5rem' },
    fieldMargin: {
        flexBasis: '48%',
        maxWidth: '48%'
    },
    currencyInputLarge: {
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333',
        height: '3.25rem',
        width: '100%',
        fontFamily: 'corporate-s,sans-serif',
        fontSize: '2.75rem',
        padding: '0 .25rem',
        border: 'none' as const
    },
    dollarPrefix: {
        alignSelf: 'center',
        fontSize: '2rem',
        paddingTop: '.5rem'
    },
    userTabsContainer: {
        borderBottom: '1px solid #BFBFBF',
        backgroundColor: 'white',
        height: '50px'
    },
    userTab: { padding: 0 },
    greenIndicator: {
        height: '5px',
        background: '#5AAC01'
    },
    redIndicator: {
        height: '5px',
        background: '#EA3323'
    },
    tabContainer: { width: '60%' },
    inputLabel: {
        color: theme?.app?.applicationColors.enumColors.grey || '#4a4a4a',
        fontSize: '.8rem',
        marginBottom: '.3rem',
        fontFamily: 'corporate-s,sans-serif'
    },
    priceDisplay: {
        fontSize: '14px',
        fontWeight: 'bold' as const
    },
    priceValue: {
        fontSize: '20px',
        fontWeight: 'bold' as const
    }
});

export default muiStyles;